import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';
import { CircularProgress, Container, Typography, TextField, FormGroup, Checkbox, FormControlLabel } from '@mui/material';
import { Button } from '@lexcelon/react-util';
import ReactPhoneInput from 'react-phone-input-material-ui';

// Redux
import { connect } from 'react-redux';
import { clearErrors, setError } from '../../../../alerts';
import { createUserAccount } from '../../../../redux/actions/authActions';

// Images
import ColorLogo from '../../../../images/ColorLogo.png';

// API
import { checkInvitation } from '../../../../api';

// Constants
import { NAVY } from '../../../../constants';

class CreateAccount extends Component {
  constructor(props) {
    super(props);

    this.state = {
      firstName: '',
      lastName: '',
      phoneNumber: '',
      email: '',
      password: '',
      confirmPassword: '',
      isTokenValid: null,
      isCheckingToken: true,

      agree1: false,
      agree2: false,
    };
  }

  componentDidMount() {
    const token = this.props.match?.params?.token;
    checkInvitation(token).then(userInvitation => {
      this.setState({ isCheckingToken: false, isTokenValid: true, email: userInvitation.getEmail() });
    }).catch(error => {
      setError(error);
      this.setState({ isCheckingToken: false, isTokenValid: false });
    });
  }

  componentWillUnmount() {
    clearErrors();
  }

  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  onSubmit = (e) => {
    e.preventDefault();

    const {
      firstName,
      lastName,
      email,
      phoneNumber,
      password,
      confirmPassword
    } = this.state;

    // Make sure passwords match
    if (password !== confirmPassword) {
      setError('Error: Passwords must match');
      return;
    }

    if (phoneNumber?.length <= 3) {
      setError('Error: Invalid phone number');
      return;
    }

    const token = this.props.match?.params?.token;
    this.props.createUserAccount({ firstName, lastName, email, phoneNumber, password }, token);
  };

  render() {
    return (
      <Container>
        <form autoComplete='off' onSubmit={this.onSubmit} style={{ marginBottom: '5em' }}>
          {/* ----- LOGO & TITLE ----- */}
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '2em', marginBottom: '1em' }}>
            <img
              width={250}
              src={ColorLogo}
              alt={'FlyWire Logo'}
              title={'FlyWire Logo'}
              style={{ objectFit: 'contain' }}
            />
          </div>

          <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '10px', justifyContent: 'center', alignItems: 'center' }}>
            <Typography variant='h1' style={{ textAlign: 'center' }}>Create an Account</Typography>
            {this.state.isCheckingToken && <CircularProgress style={{ marginLeft: '20px' }} />}
          </div>

          {/* ----- PERSONAL INFORMATION ----- */}
          <Typography variant='h2' style={{ marginBottom: '10px', marginTop: '20px' }}>Personal Information</Typography>

          {/* Name Input */}
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', marginBottom: '10px' }}>
            <TextField required error={this.state.formError && this.state.firstName === ''} name='firstName' label='First Name' style={{ width: '49%' }} value={this.state.firstName} onChange={this.onChange} variant='filled' disabled={this.props.isLoading || !this.state.isTokenValid} />
            <TextField required error={this.state.formError && this.state.lastName === ''} name='lastName' label='Last Name' style={{ width: '49%' }} value={this.state.lastName} onChange={this.onChange} variant='filled' disabled={this.props.isLoading || !this.state.isTokenValid} />
          </div>

          {/* Email Input */}
          <TextField
            name='email'
            label='Email'
            type='email'
            style={{ width: '100%', marginBottom: '10px' }}
            value={this.state.email}
            variant='filled'
            disabled
          />

          {/* Phone Number */}
          <ReactPhoneInput
            country='us'
            preferredCountries={['us', 'cn']}
            value={this.state.phoneNumber}
            onChange={(phoneNumber) => this.setState({ phoneNumber })}
            component={TextField}
            inputProps={{ variant: 'filled', required: true, label: 'Phone Number', disabled: this.props.isLoading || !this.state.isTokenValid, error: this.state.formError && this.state.phoneNumber?.length <= 3 }}
            containerStyle={{ width: '100%' }}
          />
          <Typography variant='button' style={{ color: 'dimgrey', marginBottom: '10px' }}>Your phone number is used exclusively for the purposes of two-factor authentication.</Typography>

          {/* ----- CREATE PASSWORD ----- */}
          <Typography variant='h2' style={{ marginBottom: '10px', marginTop: '20px' }}>Create Password</Typography>
          <TextField
            required
            error={this.state.formError && this.state.password === ''}
            name='password'
            label='Password'
            style={{ width: '100%', marginBottom: '10px' }}
            value={this.state.password}
            onChange={this.onChange}
            variant='filled'
            type='password'
            disabled={this.props.isLoading || !this.state.isTokenValid}
          />

          <TextField
            required
            error={this.state.formError && this.state.confirmPassword === ''}
            name='confirmPassword'
            label='Confirm Password'
            style={{ width: '100%', marginBottom: '20px' }}
            value={this.state.confirmPassword}
            onChange={this.onChange}
            variant='filled'
            type='password'
            disabled={this.props.isLoading || !this.state.isTokenValid}
          />

          <FormGroup>
            <FormControlLabel onChange={e => this.setState({ agree1: e.target.checked })} required control={<Checkbox />} style={{ color: 'dimgrey' }} label='By checking this box, you agree to be contacted via the phone number listed above for the purposes of two factor authentication. *' />
            <FormControlLabel onChange={e => this.setState({ agree2: e.target.checked })} required control={<Checkbox />} style={{ color: 'dimgrey' }} label='By checking this box, you agree to our terms and conditions. *' />
          </FormGroup>

          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', marginTop: '40px' }}>
            <Button type='submit' variant='contained' color='primary' isLoading={this.props.isLoading} disabled={!this.state.isTokenValid || !this.state.agree1 || !this.state.agree2} style={{ width: '50%' }}>
              Create Account
            </Button>
            <Typography variant='button' style={{ marginTop: '10px' }}>Already have an account?{' '}
              <Link to='/auth/login' style={{ color: NAVY }}>
                Log in now
              </Link>.
            </Typography>
            <Typography variant='button' style={{ marginTop: '10px' }}>
              <Link to='/terms-and-conditions' style={{ color: NAVY }}>
                Terms and Conditions
              </Link>{' - '}
              <Link to='/privacy-policy' style={{ color: NAVY }}>
                Privacy Policy
              </Link>
            </Typography>
          </div>
        </form>
      </Container>
    );
  }
}

CreateAccount.propTypes = {
  createUserAccount: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  match: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
  isLoading: state.auth.isLoading
});

const mapDispatchToProps = (dispatch) => ({
  createUserAccount: (userObj, token) => createUserAccount(dispatch, userObj, token)
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CreateAccount));
